<template>
  <div>
    <v-btn
      class="accounts-edit-pencil"
      style="width: 30px; height: 30px"
      outline
      small
      fab
      @click="check($event)"
      :disabled="processing"
      v-if="!isCustomerReceiptInitiate"
      color="orange"
    >
      <v-icon>edit</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="35%"
      persistent
      content-class="price-type-dialog"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="price-type-card">
          <header class="price-type-header">
            <div class="price-type-header__brand">
              <div class="price-type-header__badge" aria-hidden="true">
                <v-icon>local_offer</v-icon>
              </div>
              <h2 class="price-type-title">Price Type</h2>
            </div>
            <v-btn
              icon
              class="price-type-close"
              :disabled="processing"
              title="Close"
              @click.prevent="close"
            >
              <v-icon color="orange">close</v-icon>
            </v-btn>
          </header>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>

          <v-layout
            row
            align-center
            style="padding: 20px 5px 0px 5px !important"
          >
            <v-flex xs7 class="title-layout-size">
              <v-radio-group
                class="mt-0 pt-0"
                v-model="priceType"
                row
                :mandatory="true"
                :rules="[rules.required]"
              >
                <div>
                  <div class>
                    <v-layout>
                      <v-radio
                        label="Inclusive"
                        value="Inclusive"
                        color="black"
                        style="margin-right: 100px !important"
                        class="col-md-6"
                      ></v-radio>
                      <v-radio
                        label="Exclusive"
                        value="Exclusive"
                        color="black"
                        class="col-md-6"
                      ></v-radio>
                    </v-layout>
                  </div>
                </div>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="orange darken-1"
              :disabled="processing"
              flat
              @click="close()"
              >CLOSE</v-btn
            >
            <v-btn
              color="orange darken-1"
              :disabled="processing"
              flat
              @click="editPriceType()"
              >SUBMIT</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
      <v-snackbar
        :timeout="3000"
        bottom
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { StorageKeys } from "../../../constants/constants";
import ErrorBox from "@/components/Common/ErrorBox";
export default {
  components: {
    ErrorBox,
  },

  data() {
    return {
      priceType: "",
      customerStatus: "",
      valid: true,
      lazy: false,
      reason: "",
      processing: false,
      operationName: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
        amount: (v) =>
          /^\d*(\.\d+)?$/.test(v) || "Enter a valid amount. E.g 10 or 10.20",
        number: (v) => /^[0-9]*$/.test(v) || "Please enter valid amount",
      },

      error: null,
    };
  },
  props: {
    jobId: Number,
    chargesType: String,
    isCustomerReceiptInitiate: Boolean,
  },
  created() {},
  methods: {
    open() {
      this.dialog = true;
      this.priceType = this.$props.chargesType;
    },
    async check(e) {
      e.stopPropagation();
      this.processing = true;
      this.operationName = "job-price-type-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.processing = false;
        this.open();
      } else {
        return;
      }
    },
    close() {
      this.dialog = false;
      this.priceType = "";
      this.$refs.form.resetValidation();
    },
    getTime(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },
    async editPriceType() {
      this.operationName = "job-price-type-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.processing = true;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let body = {
          jobId: this.$props.jobId.toString(),
          chargesType: this.priceType,
        };
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        this.axios
          .post(
            `${this.constants.apiUrl}/dmsAdmin/changeChargesType`,
            body,
            config
          )
          .then(
            (response) => {
              const { status, data } = response.data;
              this.processing = false;
              this.dialog = false;
              this.$emit("account-list-refresh");
            },
            (error) => {
              this.processing = false;
              this.error = error.response.data.message;
            }
          );
      } else {
        this.processing = false;
        return;
      }
    },
  },
};
</script>
<style scoped>
.messagebtn {
  margin: 0 auto;
}
.title-layout-size {
  padding: 0px 16px !important;
}
.title {
  font-size: 18px;
  font-weight: 500;
}

.price-type-card {
  overflow: hidden;
  padding: 0 !important;
}

.price-type-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.75rem 1rem;
}

.price-type-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.price-type-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  position: relative;
  width: 2.35rem;
}

.price-type-header__badge::after {
  background: #f58220;
  border-radius: 999px;
  bottom: 0.26rem;
  content: "";
  height: 0.18rem;
  left: 0.48rem;
  position: absolute;
  right: 0.48rem;
}

.price-type-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
  margin-top: -0.1rem;
}

.price-type-title {
  color: #1c2b5f !important;
  font-size: 1rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}

.price-type-close {
  color: #f58220 !important;
}

.price-type-close .v-icon {
  color: #f58220 !important;
}
</style>
